<template>
    <div class="box home-box" :class="{'source18-pad': init.source == '18'}">
        
        <div class="top-box">
            <div class="top">
                <h5>
                    <a href="javascript:history.back(-1);"></a>
                    <span v-text="init.title"></span>
                </h5>
                <div class="icon-box" :class="{'active': !init.homeBackUrl}">
                    <div class="item vs" @click="screenBtnHrefFun('btnVS')">
                        <span v-if="screenData.length>0" v-text="screenData.length"></span>
                    </div>
                    <!-- <div class="item menu" :class="{'active': isMenu}" @click="isMenuFun()"></div> -->
                    <a v-if="init.homeBackUrl" class="item index" @click="btnIndexHrefFun( init.homeBackUrl )" href="javascript: void(0)"></a>
                </div>
            </div>

            <div class="btn-box">
                <div class="l">
                    <p v-for="(item, index) in sortBtn" :key="index" :class="{'active': item.status}" @click="sortBtnFun(item, index)">
                        {{item.name}}
                        <span v-if="item.name=='价格'" class="arrow">
                            <i class="iconfont" :class="{'active': item.type===0}">&#xe62d;</i>
                            <i class="iconfont" :class="{'active': item.type===1}">&#xe62e;</i>
                        </span>
                    </p>
                </div>
                <div class="r" @click="isScreenPageFun()" :class="{'active': !screenConditionStatus}">
                    <i v-text="init.filterLabel"></i>
                    <span v-if="screenNum>0" v-text="screenNum"></span>
                </div>
            </div>
        </div>

        <div class="list-data">
            <!-- <vue-scroll :ops="ops" ref="vs">
                <div class="list-view">
                    <div class="item" v-for="(item, index) in listData" :key="index">
                        <div v-if="item.status" class="screen-btn" @click="screenFun('screen', item, index)"></div>
                        <div v-else class="screen-btn active" @click="screenFun('cancel', item, index)"></div>
                        <div class="pic">
                            <img :src="item.imageUrl">
                        </div>
                        <h5 v-if="item.name" v-text="item.name"></h5>
                        
                        <template v-if="item.showType==0">
                            <div class="price" v-show="item.promotionPrice!=0 && item.isStrategy == 2">
                                <span class="span-0">¥</span>
                                <span class="span-1">{{item.finalPrice | filterPrice(item.finalPrice)}}</span>
                                <span class="span-2">¥{{item.price | filterPrice(item.price)}}</span>
                            </div>
                            <div class="price price2" v-show="item.promotionPrice==0 && item.isStrategy == 2">
                                <i class="i1">指导价：</i>
                                <i class="i2"><em>¥</em>{{item.finalPrice | filterPrice(item.finalPrice)}}</i>
                            </div>
                            <div class="price price2 price3" v-show="item.isStrategy != 2">
                                <i class="i2">敬请期待</i>
                            </div>
                        </template>
                        <template v-if="item.showType==1">
                            <div class="price price2" v-show="item.isStrategy == 2">
                                <i class="i1">指导价：</i>
                                <i class="i2"><em>¥</em>{{item.finalPrice | filterPrice(item.finalPrice)}}</i>
                            </div>
                            <div class="price price2 price3" v-show="item.isStrategy != 2">
                                <i class="i2">敬请期待</i>
                            </div>
                        </template>


                        <div class="btn2-box">
                            <a v-if="item.continueToMatchUrl" @click="btnHrefFun(item.continueToMatchUrl, 'dingZhi')" href="javascript: void(0)">立即定制</a>
                            <a v-if="item.configurationDetailUrl" @click="btnHrefFun(item.configurationDetailUrl, 'xiangQing')" href="javascript: void(0)">车型详情</a>
                        </div>
                    </div>
                </div>
            </vue-scroll> -->

            <swiper :options="options" ref="mySwiper">
                <swiperSlide v-for="(item, index) in listData" :key="index">
                    <div class="item">
                        <div v-if="item.status" class="screen-btn" @click="screenFun('screen', item, index)"></div>
                        <div v-else class="screen-btn active" @click="screenFun('cancel', item, index)"></div>
                        <div class="pic">
                            <img :src="item.imageUrl">
                        </div>
                        <h5 v-if="item.name" v-text="item.name"></h5>
                        
                        <template v-if="item.showType==0">
                            <div class="price" v-show="item.promotionPrice!=0 && item.isStrategy == 2">
                                <span class="span-0">¥</span>
                                <span class="span-1">{{item.finalPrice | filterPrice(item.finalPrice)}}</span>
                                <span class="span-2">¥{{item.price | filterPrice(item.price)}}</span>
                            </div>
                            <div class="price price2" v-show="item.promotionPrice==0 && item.isStrategy == 2">
                                <i class="i1">指导价：</i>
                                <i class="i2"><em>¥</em>{{item.finalPrice | filterPrice(item.finalPrice)}}</i>
                            </div>
                            <div class="price price2 price3" v-show="item.isStrategy != 2">
                                <i class="i2">敬请期待</i>
                            </div>
                        </template>
                        <template v-if="item.showType==1">
                            <div class="price price2" v-show="item.isStrategy == 2">
                                <i class="i1">指导价：</i>
                                <i class="i2"><em>¥</em>{{item.finalPrice | filterPrice(item.finalPrice)}}</i>
                            </div>
                            <div class="price price2 price3" v-show="item.isStrategy != 2">
                                <i class="i2">敬请期待</i>
                            </div>
                        </template>


                        <div class="btn2-box">
                            <a v-if="item.continueToMatchUrl" @click="btnHrefFun(item.continueToMatchUrl, 'dingZhi')" href="javascript: void(0)">立即定制</a>
                            <a v-if="item.configurationDetailUrl" @click="btnHrefFun(item.configurationDetailUrl, 'xiangQing')" href="javascript: void(0)">车型详情</a>
                        </div>
                    </div>
                </swiperSlide>
                
            </swiper>
            <div class="swiper-scrollbar swiper-scrollbar-1"></div>
        </div>

        <ScreenPage v-if="screenConditionStatus" class="screen-page"
            ref="screenPage"
            :class="{'active': isScreenPage}"
            :_slideData8g="screenCondition8g"
            :_slideData8h="screenCondition8h" 
            :_isBtnShow="isBtnShow"
            :_initData="init"
            @_isScreenPageFun="isScreenPageFun"
            @_submitFun="loadListDataFun">
        </ScreenPage>

        <MessageBox v-show="isMessageBox" @_isMessageBox="isMessageBoxFun"></MessageBox>

        <div class="menu-mask" v-show="isMenu"></div>
        <Menu class="menu-com" :class="{'trans': isMenu, 'active': isMenu}"></Menu>

        <!-- 初始化页面时暂无数据时显示 -->
        <div class="no-data-box" v-if="initNoData">
            <div class="view">
                <img src="../../assets/noData.png" alt="">
                <p>暂无数据</p>
            </div>
        </div>

        <!-- 接口调用时暂无数据时显示 -->
        <div class="no-data-box no-data-box2" v-if="clickNoData">
            <div class="view">
                <img src="../../assets/noData.png" alt="">
                <p>暂无数据</p>
            </div>
        </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import Vue from "vue";
import vuescroll from 'vuescroll';
import 'vuescroll/dist/vuescroll.css';
Vue.use(vuescroll);

import ScreenPage from "../../components/pc/screenPage.vue";
import MessageBox from '../../components/pc/messageBox.vue';
import Menu from '../../components/pc/menu.vue';

import http from '../../common/api/user.js';  
import { getRequest2, conversionArr, isInclude } from '../../common/public.js';

import productCodeApi from '../../common/productCodeApi.js';  

export default {
    components: {
        ScreenPage,
        MessageBox,
        Menu,
        swiper, 
        swiperSlide,
    },
    data () {
        return {
            init: {
                featureCodes: "A03C",
                count: null,
                priceMax: null,
                priceMin: null,
                filterLabel: "筛选",
                homeBackUrl: "",
                title: "",
            },
            sortBtn:[{name: "默认", status: false}, {name: "热销", status: false}, {name: "价格", status: false, type: null,}],
            ops: {
                scrollPanel: {
                    scrollingX: true,
                    scrollingY: false,
                },
                rail: {
                    opacity: 0,
                },
                bar: {
                    keepShow: true,
                    background: "#999",
                    minSize: 0.1,
                    size: '4px'
                }
            },
            screenConditionStatus: false,
            screenCondition8g: {},
            screenCondition8h: {},
            screenCondition6o: [],
            isScreenPage: false,
            listData: [],
            screenData: [],
            isMessageBox: false,
            isMenu: false,
            configurationComparisonUrl: "",
            isBtnShow: "",
            initCount: 1,
            screenNum: 0,
            initNoData: false,
            clickNoData: false,
            sidModesList: [],
            sortTypeIM: {},
            dingzhiBtn: {
                isConfigDetails: false
            },
            options: {
                notNextTick: true,
				loop: false, // 循环
				speed: 500,  // 滑动速度
				centeredSlides: false,  // 若为真，那么活动块会居中，而非默认状态下的居左
				slidesPerView: 4,
				initialSlide: 0,
				spaceBetween: 0,
				preventLinksPropagation:true, //拖动释放时不会输出信息，阻止click冒泡。拖动Swiper时阻止click事件。
                mousewheel: true,
                scrollbar: {
                    el: ".swiper-scrollbar-1",
                    hide: false,
                    snapOnRelease: false,
                    draggable: true
                },
            },
            freezeCodes: [],
        }
    },
    created () {
        // http://localhost:8080/h5/spidermicro/spider-onepage-h5/#/?vehicleType=V80&source=0&mode=0
        let urlParams = getRequest2();
        this.init.vehicleType = urlParams.vehicleType || "";
        this.init.source = urlParams.source || "";
        this.init.mode = urlParams.mode || "";

        // 初始化用户上次选中的筛选条件
        let httpParamsIM = sessionStorage.getItem(this.init.vehicleType+"httpParamsIM") ? JSON.parse(sessionStorage.getItem(this.init.vehicleType+"httpParamsIM")) : {};
        this.init.featureCodes = httpParamsIM.featureCodes ? httpParamsIM.featureCodes : this.init.featureCodes;
        this.screenNum = httpParamsIM.screenNum ? httpParamsIM.screenNum : this.screenNum;
        
        // 初始化排序按钮状态
        this.sortTypeIM = sessionStorage.getItem("sortTypeIM") ? JSON.parse(sessionStorage.getItem("sortTypeIM")) : {};
        if(this.sortTypeIM.index)
            this.$set(this.sortBtn, this.sortTypeIM.index, this.sortTypeIM.item);
        else
            this.sortBtn[0].status = true;

        this.loadScreenDataFun({
            "mutiReqList": [
                {
                    "accessToken": "SaicMaxus_31_3z",
                    "category": "8g",
                    "pageNum": 1,
                    "pageSize": 200,
                    "sFilter": {
                        "vehicleType": this.init.vehicleType,
                        "source": this.init.source,
                        "active": true
                    }
                },{
                    "accessToken": "SaicMaxus_31_3z",
                    "category": "8h",
                    "pageNum": 1,
                    "pageSize": 200,
                    "sFilter": {
                        "vehicleType": this.init.vehicleType,
                        "source": this.init.source,
                        "active": true
                    }
                },{
                    "accessToken": "SaicMaxus_31_3z",
                    "category": "6o",
                    "pageNum": 1,
                    "pageSize": 200,
                    "sFilter": {
                        "vehicleType": this.init.vehicleType,
                        "source": this.init.source,
                        "active": true
                    }
                },{
                    "accessToken": "SaicMaxus_31_3z",
                    "category": "9f",
                    "pageNum": 1,
                    "pageSize": 200,
                    "sFilter": {
                        "productCode": productCodeApi[this.init.vehicleType],
                        "source": this.init.source,
                        "active": true
                    }
                }
            ]
        }, httpParamsIM.screenNum);

        // 是否是选配对比页面点击删除按钮回到推车页面的
        // let isBtnDelete = localStorage.getItem("isBtnDelete") || "";
        // let sidModes = localStorage.getItem(this.init.vehicleType+"sidModes") || "";
        // let sidLists = [];
        // // 初始化上次用户选中的车辆
        // if(isBtnDelete == "yes"){  // 对比页面删除车辆回来
        //     let sidModes22 = localStorage.getItem(this.init.vehicleType + "sidModes22");
        //     sidLists =  sidModes22.split(",");
        //     let sidLists22 =  sidModes.split(",") || [];
        //     sidLists.forEach((item, index) => {
        //         sidLists22.forEach(item2 => {
        //             if(item == item2) sidLists.splice(index, 1);
        //         })
        //     })
        //     localStorage.removeItem("isBtnDelete");
        // }else{  // 正常刷新逻辑
        //     sidLists =  sidModes.split(",");
        // }
        // for(let i=0; i<sidLists.length; i++){
        //     if(sidLists[i]){
        //         let sidItem = sidLists[i].split(":") || [];
        //         if(sidItem[0])
        //             this.sidModesList.push(sidItem[0]);           
        //     }
        // }
        // 初始化上次用户选中的车辆
        let sidModes = localStorage.getItem(this.init.vehicleType+"sidModes") || "";
        let sidLists = [];
        if(sidModes){
            sidLists =  sidModes.split(",");
            for(let i=0; i<sidLists.length; i++){
                if(sidLists[i]){
                    let sidItem = sidLists[i].split(":") || [];
                    if(sidItem[0])
                        this.sidModesList.push(sidItem[0]);           
                }
            }
        }
        let fromSpderEntry = sessionStorage.getItem('showDialog4Onepage');
        if(fromSpderEntry){
          this.isScreenPageFun();
          sessionStorage.removeItem('showDialog4Onepage');
        }
        
        if(this.getUrlParam('fromEntry') == '1'){
          console.log(this.getUrlParam('fromEntry'));
          sessionStorage.setItem('showDialog4Onepage',1);
          window.location.href = this.changeURLArg(window.location.href,'fromEntry',0);
          location.reload();
        }
    },
    mounted() {
        let thisinterval = setInterval(()=>{
            if(wx.scrm) {
              initUDP(process.env.VUE_APP_UDP_KEY);
              clearInterval(thisinterval);
        }
        },100);

        setTimeout(()=>{
            if(!wx.scrm) clearInterval(thisinterval);
        },2000);
    },    
    methods: {
         changeURLArg(url,arg,arg_val){
            var pattern=arg+'=([^&]*)';
            var replaceText=arg+'='+arg_val;
            if(url.match(pattern)){
                var tmp='/('+ arg+'=)([^&]*)/gi';
                tmp=url.replace(eval(tmp),replaceText);
                return tmp;
            }else{
                if(url.match('[\?]')){
                    return url+'&'+replaceText;
                }else{
                    return url+'?'+replaceText;
                }
            }
        },
        getUrlParam(name) {
            var reg = new RegExp("(^|&?)" + name + "=([^&]*)(&|$)", "i");
            var r = window.location.search.substr(1).match(reg);
            if (r != null) return unescape(r[2]);

            r = window.location.hash.substr(1).match(reg);
            if (r != null) return unescape(r[2]);
            return null;
        },
        btnIndexHrefFun( url ){
            let aa = url.indexOf("?");
            let SpiderX = this.$route.query.SpiderX || "";
            let dmsCode = this.$route.query.dmsCode || this.getUrlParam('dmsCode');
            let su = this.$route.query.su || this.getUrlParam('su');
            if(SpiderX){
                url += (aa == -1 ? "?SpiderX=" + SpiderX : "&SpiderX=" + SpiderX);
            }
            if(dmsCode){
                url += '&dmsCode=' + dmsCode;
            }
            if(su){
                url += '&su=' + su;
            }
            window.location.href = url;
        },
        btnHrefFun(url, btn){
            let aa = url.indexOf("?");
            if(aa == -1){
                url += '?source=' + this.init.source + '&mode=' + this.init.mode;
            }else{
                url += '&source=' + this.init.source + '&mode=' + this.init.mode;
            }
            let SpiderX = this.$route.query.SpiderX || "";
            let dmsCode = this.$route.query.dmsCode || this.getUrlParam('dmsCode');
            let su = this.$route.query.su || this.getUrlParam('su');
            if(SpiderX) url += "&SpiderX=" + SpiderX;
            
            if(dmsCode) url += "&dmsCode=" + dmsCode;
            if(su) url += "&su=" + su;
            if(btn == "dingZhi" && this.dingzhiBtn.isConfigDetails) url = url.replace("optionalcar", "configDetails");
            
            window.location.href = url;
        },
        sortBtnFun(item, index){  // 排序功能实现
            for(let i=0; i<this.sortBtn.length; i++){ this.sortBtn[i].status = false; }
            item.status = true;
            if(item.name == "价格"){
                item.type = item.type===0 ? 1 : 0;
            }else{
                this.sortBtn[2].type = null;
            }
            this.$set(this.sortBtn, index, item);

            this.sortTypeIM = item;

            sessionStorage.setItem('sortTypeIM', JSON.stringify( {index: index, item: item} ));

            this.$SCRM.clickevent('c_sortevent',{c_carser: this.screenCondition8h.list[0].record.productCode,c_sorttype: item.name,c_sortdirection:item.type});
            if(item.name == "默认"){
                this.loadListDataFun({
                    featureCodes: this.init.featureCodes,
                    productCode: this.screenCondition8h.list[0].record.productCode || "V80802",
                }, "init");
            }else if(item.name == "热销"){
                this.loadListDataFun({
                    featureCodes: this.init.featureCodes,
                    productCode: this.screenCondition8h.list[0].record.productCode || "V80802",
                    hot: 1,
                }, "init");
            }else if(item.name == "价格"){  // order: 空和0，价格从高到低，1时价格从低到高
                this.loadListDataFun({
                    featureCodes: this.init.featureCodes,
                    productCode: this.screenCondition8h.list[0].record.productCode || "V80802",
                    order: item.type+"",
                }, "init");
            }

            localStorage.removeItem(this.init.vehicleType+"sidModes");
            localStorage.removeItem(this.init.vehicleType + "sidModes22");
            this.sidModesList = [];
        },
        isScreenPageFun(){
            this.isScreenPage = !this.isScreenPage;
        },
        screenFun(type, item, index){  // 对比车型选择，最多选择4辆
            if(this.screenData.length==2 && type==='screen'){
                this.isMessageBox = true;
                return;
            }
            this.listData[index].status = !this.listData[index].status;
            this.listData = [].concat(this.listData);
            if(type === 'screen'){
                this.screenData.push(item);
            }else{
                for(let i in this.screenData){
                    if(this.screenData[i].sid===item.sid){
                        this.screenData.splice(i, 1);
                    }
                }
            }
            this.screenBtnHrefFun('btnScreen');
        },
        isMessageBoxFun(){
            this.isMessageBox = !this.isMessageBox;
        },
        isMenuFun(){
            this.isMenu = !this.isMenu;
        },
        loadScreenDataFun( params, screenNum ){  // 筛选条件加载
            http.getMultiSfilterRecordList1( params ).then(res=>{
                if(res.success){
                    this.screenCondition8g = res.multiRecordList[0] || {};
                    this.screenCondition8h = res.multiRecordList[1] || {};
                    this.screenCondition6o = res.multiRecordList[2].list || [];

                    if(res.multiRecordList.length && res.multiRecordList[3].list.length && res.multiRecordList[3].list[0].record.active)
                        this.dingzhiBtn = res.multiRecordList[3].list[0].record;

                    if(res.multiRecordList[1].list.length > 0){
                        this.screenConditionStatus = true;
                        this.init.title = res.multiRecordList[1].list[0].record.title;
                        this.init.filterLabel = res.multiRecordList[1].list[0].record.filterLabel;
                        this.init.homeBackUrl = res.multiRecordList[1].list[0].record.homeBackUrl;
                        
                        let initData = {
                            featureCodes: this.init.featureCodes,
                            productCode: res.multiRecordList[1].list[0].record.productCode,
                            screenNum: screenNum ? screenNum : null,
                        };
                        if(this.sortTypeIM.index){
                            if(this.sortTypeIM.item.name == "热销"){
                                initData.hot = 1;
                            }else if(this.sortTypeIM.item.name == "价格"){  // order: 空和0，价格从高到低，1时价格从低到高
                                initData.order = this.sortTypeIM.item.type + "";
                            }
                        }
                        this.loadListDataFun(initData, "init");

                    }else{
                        this.initNoData = true;
                    }
                }else{
                    this.initNoData = true;
                }
            }).catch(err=>{
                console.log(err);
                this.initNoData = true;
            });
        },
        // getQuestionId () {
        //     let id =  "0";
        //     let handlerHoist = sessionStorage.getItem(this.init.vehicleType + "handlerHoistIM") || "[]";
        //     if(handlerHoist == undefined || handlerHoist == 'undefined' || !handlerHoist)
        //         handlerHoist = "[]"
        //     handlerHoist = JSON.parse(handlerHoist);
        //     if(handlerHoist.length)
        //         id = handlerHoist[handlerHoist.length - 1].record.sort;
        //     return id;
        // },
        loadListDataFun( params, source ){  // 列表数据加载
            // let questionId = this.getQuestionId();

            this.screenData = [];
            let fixedFeatureCodes = this.$route.query.fixedFeatureCodes || "";
            if(fixedFeatureCodes){
                params.featureCodes = fixedFeatureCodes ? params.featureCodes + "," + fixedFeatureCodes : fixedFeatureCodes;
            }

            params.featureCodes = params.featureCodes ? params.featureCodes : "A03C";
            if(this.init.mode==10 || this.init.mode==12){
                params.dealer = 1;
            }
            if(source === "screenPage"){
                this.init.featureCodes = params.featureCodes;
                this.initSortFun();
                this.initCount ++;
                this.screenNum = params.screenNum;
            }

            let paramsNew = {
                // questionId: questionId,
                answerCodes: params.featureCodes,
                dealer: this.init.source == '1' ? 1 : 0,
                source: this.init.source || '0',
                productCode: productCodeApi[this.init.vehicleType],
            }
            if( params.hasOwnProperty('order') ) {
                paramsNew.order = params.order;
            }

            http.getCommercialPackageByFeatureCodes(paramsNew).then(res=>{
                if(res.success){
                    if(source === "screenPage"){
                        sessionStorage.setItem(this.init.vehicleType+"httpParamsIM", JSON.stringify(params));
                        sessionStorage.setItem("httpParamsIM", JSON.stringify(params));
                    }
                    this.configurationComparisonUrl = res.data.configurationComparisonUrl || "";
                    this.listData = res.data.packageVoList || [];
                    this.freezeCodes = res.data.freezeCodes || [];
                    this.clickNoData = this.listData.length ? false : true;
                    for(let index in this.listData){
                        this.listData[index].status = true;
                        for(let j=0; j<this.sidModesList.length; j++){  // 每次列表数据变化实时更新选中状态
                            if(this.listData[index].sid == this.sidModesList[j]){
                                this.listData[index].status = false;
                                this.screenData.push(this.listData[index]);
                            }
                        }
                        this.listData[index].isStrategy = this.isSelectFeature(this.listData[index]);
                    }
                    this.init.count = res.data.count || 0;
                    this.init.priceMax = res.data.priceMax || null;
                    this.init.priceMin = res.data.priceMin || null;
                    if(source === "screenPage"){
                        if(res.success && res.data.packageVoList.length>0){
                            this.isBtnShow = "tuijian&" + this.initCount;
                        }else{
                            this.isBtnShow = "noData&" + this.initCount;
                        }
                    }
                    
                    // this.$refs.screenPage.updateData8g(questionId, this.freezeCodes);
                    this.$refs.screenPage.updateData8g(null, this.freezeCodes);
                }else{
                    this.isBtnShow = "noData&" + this.initCount;
                    this.clickNoData = true;
                    this.listData = [];
                }
            }).catch(err=>{
                this.isBtnShow = "noData&" + this.initCount;
                this.clickNoData = true;
            });

            // http.getRecommendPackageByFeatureCodes( params ).then(res=>{
            //     if(res.success){
            //         if(source === "screenPage"){
            //             sessionStorage.setItem(this.init.vehicleType+"httpParamsIM", JSON.stringify(params));
            //             sessionStorage.setItem("httpParamsIM", JSON.stringify(params));
            //         }
            //         this.configurationComparisonUrl = res.data.configurationComparisonUrl || "";
            //         this.listData = res.data.listPackageVo || [];
            //         for(let index in this.listData){
            //             this.listData[index].status = true;
            //             for(let j=0; j<this.sidModesList.length; j++){  // 每次列表数据变化实时更新选中状态
            //                 if(this.listData[index].sid == this.sidModesList[j]){
            //                     this.listData[index].status = false;
            //                     this.screenData.push(this.listData[index]);
            //                 }
            //             }
            //             this.listData[index].isStrategy = this.isSelectFeature(this.listData[index]);
            //         }
            //         this.init.count = res.data.count || 0;
            //         this.init.priceMax = res.data.priceMax || null;
            //         this.init.priceMin = res.data.priceMin || null;
            //         if(source === "screenPage"){
            //             if(res.success && res.data.listPackageVo.length>0){
            //                 this.isBtnShow = "tuijian&" + this.initCount;
            //             }else{
            //                 this.isBtnShow = "noData&" + this.initCount;
            //             }
            //         }
            //         if(this.listData.length>0){
            //             this.clickNoData = false;
            //         }else{
            //             this.clickNoData = true;
            //         }
            //     }else{
            //         this.isBtnShow = "noData&" + this.initCount;
            //         this.clickNoData = true;
            //     }
            // }).catch(err=>{
            //     console.log(err);
            //     this.isBtnShow = "noData&" + this.initCount;
            //     this.clickNoData = true;
            // });
        },
        isSelectFeature(obj){
            let allArr = obj.allFeatureCodes ? obj.allFeatureCodes.split(",") : [];
            let objItem = {};
            let isInc = false;
            try{
                this.screenCondition6o.forEach(itpp => {
                    if(itpp.record.active){
                        if(itpp.record.featureCode){
                            isInc = isInclude(allArr, conversionArr(itpp.record.featureCode));
                            if(isInc){
                                objItem = itpp;
                                throw new Error('End Loop')
                            }
                        }else{
                            objItem = itpp;
                        }
                    }
                });
            }catch(e){ } 
            return objItem.record ? objItem.record.strategy : false;
        },
        screenBtnHrefFun(type){  // 对比跳转，参数拼接
            let sidModes = "";
            for(let i in this.screenData){
                sidModes += this.screenData[i].sid+":"+this.screenData[i].type+","
            }
            sidModes = sidModes.substring(0, sidModes.length-1);
            localStorage.setItem(this.init.vehicleType + "sidModes", sidModes);
            localStorage.setItem("sidModes", sidModes);
            localStorage.setItem(this.init.vehicleType + "sidModes22", sidModes);

            if(this.screenData.length==0){
                return;
            }

            let url = this.configurationComparisonUrl;
            let aa = url.indexOf("?");
            if( aa == -1 ){
                url += "?fixedFeatureCodes=" + this.init.featureCodes + "&source=" + this.init.source + "&mode=" + this.init.mode;
            }else{
                url += "&fixedFeatureCodes=" + this.init.featureCodes + "&source=" + this.init.source + "&mode=" + this.init.mode;
            }
            let SpiderX = this.$route.query.SpiderX || "";
            let dmsCode = this.$route.query.dmsCode || "";
            let su = this.$route.query.su || "";
            if(SpiderX){
                url += "&SpiderX=" + SpiderX;
            }
            if(SpiderX){
                url += "&dmsCode=" + dmsCode;
            }
            if(su){
                url += "&su=" + su;
            }
            if(wx.isWXApplets) url += '&userUuid=' + this.getUrlParam('userUuid');
            if(type == 'btnVS')
                window.location.href = url;
        },
        initSortFun(){
            this.sortBtn = [{name: '默认', status: true},{name: '热销', status: false},{name: '价格', status: false, type: null,}];
            sessionStorage.removeItem("sortTypeIM");
        },
    },
}
</script>

<style lang="less" src="../../styles/pc.less"></style>
<style lang="less">
.screen-page{
    position: fixed;
	top: -1920px;
    left: -1920px;
    &.active{
        top: 0;
        left: 0;
    }
}
.menu-mask{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 980;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
}
.menu-com{  
    position: fixed;
    top: -1650px;
    right: 65px;
    z-index: 982;
    &.trans{
        transition: .6s;
    }
    &.active{
        top: 165px;
    }
}
.price3{
    i{
        margin: 0 auto;
    }
}
</style>
